import React from 'react';
import Tag from './Tag'

const selectChange = (props, feno, ev, line) => {
  const data = feno.content.filter(i => i.id === parseInt(ev.target.value)).reduce((pre, cur) => cur, {})
  props.lineSelect({ ...data, variable: feno.variable }, line)
}

const LineConfig = ({ props, line }) => {
  return (
    <div className='line-config-container'>
      <div className='line-config-top'>
        <div className='line-tag-container'>
          {
            line.title &&
            <Tag
              buttonHandler={() => { }}
              item={{ id: 0, title: line.title }}
              filterType={'filterType'}
              noClose={true}
            />
          }
        </div>
        <div className='line-options'>
          <span><input type='color' value={line.color} onChange={(e) => props.changeColor(e, line.i)}></input></span>
          <span>
            <i className={line.eye ? 'far fa-eye line-option-eye' : 'far fa-eye-slash line-option-no-eye'}
              onClick={() => props.eyeChange(line.i)}>
            </i>
          </span>
          <span><i className='far fa-trash-alt line-option-trash' onClick={() => props.removeLine(line.i)}></i></span>
        </div>
      </div>
      <div className='line-select-content'>
        {
          !line.title &&
          props.state.dataLines.map((feno, index) =>
            <select onChange={(e) => selectChange(props, feno, e, line)} key={`key-select-in-lines${feno.variable}-${index}`} className='line-selects'>
              <option disabled selected>{feno.group}</option>
              {
                feno.content.map((fen, i) => <option value={fen.id} key={`select-option-key-in-lines${feno.variable}-${fen.id}`}>{fen.title}</option>)
              }
            </select>
          )
        }
      </div>
    </div >
  )
}

export default LineConfig;